import { useEffect, useState } from "react";
import { useTagAndSegment } from "../../contexts/tagAndSegment";
import service from "../../service";
import FishTable from "../FishTable";

const SegmentReview = () => {
  const [fish, setFish] = useState([]);
  const [fishFetchedAt, setFishFetchedAt] = useState(null);
  const { segmentConditions, segmentName } = useTagAndSegment();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await service.getFishForSegmentConditions(segmentConditions);
        setFish(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error fetching segment fish:', error);
        setFish([]);
      }
      setFishFetchedAt(new Date());
    };

    fetchData();
  }, [segmentConditions]);

  const formatDate = (date) => {
    if (!date) return "";
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
    });
  };

  const formatTime = (date) => {
    if (!date) return "";
    return date
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
      .toLowerCase();
  };

  return (
    <div className="max-w-7xl mx-auto p-6 space-y-8">
      <h1 className="text-2xl font-bold text-gray-900">Segment Review</h1>
      {fish.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg shadow border-2 border-gray-200">
          <p className="text-gray-500 text-lg">No contacts match these filters</p>
        </div>
      ) : (
        <>
          <div className="bg-white rounded-lg shadow p-6 border-2 border-gray-200">
            <h1 className="text-2xl font-semibold text-gray-900 mb-4">
              {segmentName || "Untitled Segment"}
            </h1>
            <div className="flex items-center gap-6">
              <p className="text-4xl font-bold text-blue-600">{fish.length}</p>
              <div>
                <p className="text-gray-700 text-lg">contact{fish.length !== 1 ? 's' : ''} in your segment</p>
                <p className="text-sm text-gray-500">
                  as of {formatDate(fishFetchedAt)} at {formatTime(fishFetchedAt)}
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow overflow-hidden border-2 border-gray-200">
            <FishTable
              fish={fish}
              isEditable={false}
              isSelectable={false}
              isClickable={true}
              editingData={{}}
              selectedFishIds={[]}
              handleCellClickDestination={`members`}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default SegmentReview;
